import { api } from '~/services/api';

export const login = data => api.post('/auth/login', data);

export const refresh = data => api.post('/auth/refresh', data);
